import React from 'react'
import {Link} from "react-router-dom"
import LogoWhite from "../../Assets/Pngs/LogoWhite1.png"

//classes
import classes from "./Footer.css"

const Footer = (props) => {
    return (
            <div className={classes.Footer}>
                    <div className={classes.Footer}>
                        <div className={classes.Main}>
                            <div className={classes.Logo}>
                                <Link to="/"><img alt="PlayBox Logo" src={LogoWhite} className={classes.LogoFooter}/></Link>
                            </div>
                            <div className={classes.MoreGames}>
                                <h3 className={classes.Head}>Games</h3>
                                <ul>
                                    <li>
                                        <p><Link to='/PlayTicTacToe'>Play Tic Tac Toe</Link></p>
                                    </li>
                                    <li>
                                        <p><Link to='/Play2048'>Play 2048</Link></p>
                                    </li>
                                    <li>
                                        <p><Link to='/PlaySnakeGame'>Play Snake</Link></p>
                                    </li>
                                    <li>
                                        <p><Link to='/PlayDots-and-boxes'>Play Dots and Boxes</Link></p>
                                    </li>
                                    <li>
                                        <p><Link to='/PlayUltimateTicTacToe'>Play Ultimate TicTacToe</Link></p>
                                    </li>
                                </ul>
                            </div>
                            <div className={classes.UsefulLinks}>
                                <h3 className={classes.Head}>Useful Links</h3>
                                <ul>
                                    <li>
                                        <p><Link to='/Leaderboard'>Leaderboard</Link></p>
                                    </li>
                                    <li>
                                        <p><Link to='/About'>About Us</Link></p>
                                    </li>
                                </ul>
                            </div>
                            <div className={classes.FollowUs}>
                                <h3 className={classes.Head}>Follow Us</h3>
                                <ul>
                                    <li>
                                        Please follow us on our social 
                                        media page to keep yourself 
                                        update. We frequently come up
                                        with new ideas.
                                    </li>
                                </ul>

                            </div>
                            <div className={classes.ContactUs}>
                                <h3 className={classes.Head}>Contact Us</h3>
                                <ul>
                                    <li>
                                        <p>Up@playboxgames.org</p>
                                    </li>
                                    {/* <li>
                                        <p>(+91) 739 386 4605</p>
                                    </li> */}
                                    <li>
                                        <p><Link to='/Support'>Support</Link></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={classes.CopyrightSection}>
                            <p>Copyright © 2020-2021 <img alt="PlayBox Logo" src={LogoWhite} className={classes.LogoFooter}/> All rights reserved.</p>
                        </div>
                    </div>
                </div>
    )
}

export default Footer
